import { render, staticRenderFns } from "./EmptyImageUpload.vue?vue&type=template&id=c859057c&scoped=true"
import script from "./EmptyImageUpload.vue?vue&type=script&lang=js"
export * from "./EmptyImageUpload.vue?vue&type=script&lang=js"
import style0 from "./EmptyImageUpload.vue?vue&type=style&index=0&id=c859057c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c859057c",
  null
  
)

export default component.exports